import Logo from "@/common/images/logo.svg";
import "./RGLogo.scss";
import { Link } from "react-router-dom";
import { routes } from "@/common/utils/routes";

export const RGLogo = () => {
  return (
    <Link to={routes.home()} className="mainLogo" title="Back to home page" aria-label="Link to home page">
      <img src={Logo} width="47" height="40" alt="" />
    </Link>
  );
};
